import type { FC } from 'react'

import {
  Divider,
  Header,
  PrimaryButton,
  Spacer,
  TertiaryButton,
  Text,
  Toolbar,
} from '@procurify/ui'
import { useIntl } from 'react-intl'

import { AddLicensesLink } from '@webapp/platform/iam/components/AddLicensesLink'
import messages from '../../messages'
import { ImporterContentStyled as Content } from '../../styles/ImporterContentStyled'
import ErrorCSVIcon from '../ImporterErrorStage/assets/import-csv-error.png'

export interface IProLicenseExceededStageProps {
  onDismiss?: () => void
  onUploadNewFile?: () => void
}

export const ProLicenseExceededStage: FC<IProLicenseExceededStageProps> = ({
  onDismiss,
  onUploadNewFile,
}) => {
  const intl = useIntl()

  const contactSalesLink = (
    <AddLicensesLink>
      {intl.formatMessage(messages.proLicenseExceededContactSales)}
    </AddLicensesLink>
  )

  return (
    <Content>
      <Spacer />

      <img
        src={ErrorCSVIcon}
        alt={intl.formatMessage(messages.errorImageLabel)}
      />
      <Header as='h3' gutter>
        {intl.formatMessage(messages.proLicenseExceededTitle)}
      </Header>

      <Text>{intl.formatMessage(messages.proLicenseExceededDescription)}</Text>
      <Text>
        {intl.formatMessage(messages.proLicenseExceededAction, {
          contactSalesLink,
        })}
      </Text>

      <Divider space={2} />

      <Toolbar>
        <Toolbar.Fill />
        <Toolbar.Item>
          <TertiaryButton onClick={onDismiss}>
            {intl.formatMessage(messages.uploadingStepCancelButton)}
          </TertiaryButton>
          <PrimaryButton onClick={onUploadNewFile}>
            {intl.formatMessage(messages.proLicenseExceededUploadNewFile)}
          </PrimaryButton>
        </Toolbar.Item>
      </Toolbar>
    </Content>
  )
}
